import {fetchConditionList} from 'web/redux/actions/ConditionActions';
import {useEffect, useRef, useState} from 'react';
import {useDispatch} from 'react-redux';

export const useConditionListModalControl = (setNeedDispatchListLoad) => {
  const dispatch = useDispatch();
  const [conditionList, setConditionList] = useState([]);

  const dispatchListModalRef = useRef(null);
  const dispatchModalRef = useRef(null);

  useEffect(() => {
    dispatchListModalRef.current = new bootstrap.Modal(
      dispatchModalRef.current,
    );
  }, []);

  const getConditionList = (openModal = false) => {
    dispatch(fetchConditionList({}))
      .then((res) => {
        const statusCode = res.payload.code;
        if (statusCode && statusCode.isSuccessCode) {
          const conditionList = res.payload.result;
          setConditionList(conditionList);
          if (openModal) {
            toggleDispatchListModal(true);
          }
        } else {
          console.error('fetchConditionList error', res);
        }
      })
      .catch((err) => {
        console.error('fetchConditionList error', err);
      });
  };
  const toggleDispatchListModal = (show) => {
    if (show) {
      setNeedDispatchListLoad(true);
      dispatchListModalRef.current.show();
    } else {
      setNeedDispatchListLoad(false);
      dispatchListModalRef.current.hide();
    }
  };

  return {
    conditionList,
    dispatchModalRef,
    getConditionList,
    toggleDispatchListModal,
  };
};
